import React, { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import MultiSelect, { MultiSelectProps } from 'components/MultiSelect';

import { LabelsSelect_data$key } from '__generated__/LabelsSelect_data.graphql';

type Props = {
  data: LabelsSelect_data$key;
} & Omit<MultiSelectProps, 'options'>;

const LabelsSelect: FC<Props> = props => {
  const { allLabels } = useFragment(
    graphql`
      fragment LabelsSelect_data on Query {
        allLabels {
          id
          name
        }
      }
    `,
    props.data
  );

  return <MultiSelect {...props} options={allLabels} />;
};

export default LabelsSelect;
